import React from 'react';

import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Select from '../../components/Select/Select';
import OprSelect from '../../components/OprSelect/OprSelect';
import { positiveNum } from '../../validators/formValidators';
const ReactSelect = require('react-select');
const classNames = require('classnames');

require('./AlertsSettings.scss');

class AlertsSettings extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      uiInfo,
      optionList,
      toggleSettingsDisplay,
      user,
    } = this.props;
    const panelClasses = classNames('alerts-settings', {
      show: this.props.showSettings,
    });

    const panelStyle = {
      height: uiInfo.pageHeight,
      width: 0.395 * (uiInfo.pageWidth - 10),
    };

    // if(!this.props.showSettings) {
    //   return null;
    // }

    return (
      <div className={panelClasses} style={panelStyle}>
        <div className="alerts-header">
          <div className="actions">
            <i className="icon-close" onClick={toggleSettingsDisplay} />
          </div>
          <h2>{this.context.t('alerts_options')}</h2>
        </div>
        <form className="form-horizontal" onSubmit={handleSubmit}>
          {/* <fieldset>
            <legend>{this.context.t('sort_by')}</legend>
            <div className="form-group">
              <div className="col-xs-8">
                <Field
                  name="sortBy"
                  component={(props) => (
                    <Select
                      {...props}
                      placeholderTitle={this.context.t('select')}
                      clearable={false}
                      options={[
                        {
                          value: 'Priority',
                          label: this.context.t('priority_default'),
                        },
                        { value: 'ID', label: this.context.t('id') },
                        {
                          value: 'DetectedAt',
                          label: this.context.t('detected'),
                        },
                        { value: 'AlertType', label: this.context.t('type') },
                        {
                          value: 'AlertState',
                          label: this.context.t('status'),
                        },
                        {
                          value: 'Intensity',
                          label: this.context.t('intensity'),
                        },
                        {
                          value: 'WorkArea',
                          label: this.context.t('work_area'),
                        },
                        {
                          value: 'fixDate',
                          label: this.context.t('repair_date'),
                        },
                        {
                          value: 'RepairCode',
                          label: this.context.t('repair_details'),
                        },
                        {
                          value: 'ClosureDate',
                          label: this.context.t('closure_date'),
                        },
                        {
                          value: '10',
                          label: this.context.t('service_provider'),
                        },
                        //{value: '11', label: this.context.t('Days detected')},
                      ]}
                    />
                  )}
                />
              </div>
              <div className="col-xs-4">
                <Field
                  name="sortByDir"
                  component={(props) => (
                    <Select
                      {...props}
                      placeholderTitle={this.context.t('select')}
                      clearable={false}
                      backspaceRemoves={false}
                      options={[
                        { value: 'asc', label: this.context.t('asc') },
                        { value: 'desc', label: this.context.t('desc') },
                      ]}
                    />
                  )}
                />
              </div>
            </div>
          </fieldset> */ }
          <fieldset>
            <legend>{this.context.t('filters')}</legend>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('priority')}
              </label>
              <div className="col-xs-8">
                <Field
                  name="Priority"
                  component={(props) => (
                    <Select
                      {...props}
                      isSearchable={false}
                      placeholderTitle={this.context.t('select')}
                      clearable={true}
                      multi={true}
                      closeMenuOnSelect={false}
                      options={[
                        { value: 'A', label: this.context.t('a') },
                        { value: 'B', label: this.context.t('b') },
                        { value: 'C', label: this.context.t('c') },
                        { value: 'D', label: this.context.t('d') },
                      ]}
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('type')}
              </label>
              <div className="col-xs-8">
                <Field
                  name="AlertType"
                  component={(props) => (
                    <Select
                      {...props}
                      isSearchable={false}
                      placeholderTitle={this.context.t('select')}
                      clearable={true}
                      multi={true}
                      closeMenuOnSelect={false}
                      options={optionList.AlertType}
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('status')}
              </label>
              <div className="col-xs-8">
                <Field
                  name="AlertState"
                  component={(props) => (
                    <Select
                      {...props}
                      isSearchable={false}
                      placeholderTitle={this.context.t('select')}
                      clearable={true}
                      multi={true}
                      closeMenuOnSelect={false}
                      options={optionList.AlertState}
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('intensity')}
              </label>
              <div className="col-xs-2 control-numeric-opr">
                <Field name="IntensityOpr" component={OprSelect} />
              </div>
              <div className="col-xs-6">
                <Field
                  name="Intensity"
                  component="input"
                  type="number"
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('probability')}
              </label>
              <div className="col-xs-2 control-numeric-opr">
                <Field name="ProbabilityLeakOpr" component={OprSelect} />
              </div>
              <div className="col-xs-6">
                <Field
                  name="ProbabilityLeak"
                  component="input"
                  type="number"
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('work_area')}
              </label>
              <div className="col-xs-8">
                <Field
                  name="WorkArea"
                  component={(props) => (
                    <Select
                      {...props}
                      isSearchable={false}
                      placeholderTitle={this.context.t('select')}
                      clearable={true}
                      multi={true}
                      closeMenuOnSelect={false}
                      options={optionList.WorkAreas}
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('repair_details')}
              </label>
              <div className="col-xs-8">
                <Field
                  name="RepairCode"
                  component={(props) => (
                    <Select
                      {...props}
                      isSearchable={false}
                      placeholderTitle={this.context.t('select')}
                      clearable={true}
                      multi={true}
                      closeMenuOnSelect={false}
                      options={optionList.PCARepairCodesEnum}
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('detected')}
              </label>
              <div className="col-xs-3 control-date-form">
                <Field
                  name="DetectedAt-From"
                  component="input"
                  type="date"
                  className="form-control"
                />
              </div>
              <div className="col-xs-1 control-label"> {this.context.t('to')}</div>
              <div className="col-xs-3 control-date-to">
                <Field
                  name="DetectedAt-To"
                  component="input"
                  type="date"
                  className="form-control"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('repair_date')}
              </label>
              <div className="col-xs-3 control-date-form">
                <Field
                  name="fixDate-From"
                  component="input"
                  type="date"
                  className="form-control"
                />
              </div>
              <div className="col-xs-1 control-label">
                {' '}
                {this.context.t('to')}
              </div>
              <div className="col-xs-3 control-date-to">
                <Field
                  name="fixDate-To"
                  component="input"
                  type="date"
                  className="form-control"
                />
              </div>
            </div>
            {false && (
              <div className="form-group">
                <label className="col-xs-4 control-label">
                  {this.context.t('closure_date')}
                </label>
                <div className="col-xs-3 control-date-form">
                  <Field
                    name="ClosureDate-From"
                    component="input"
                    type="date"
                    className="form-control"
                  />
                </div>
                <div className="col-xs-1 control-label">
                  {' '}
                  {this.context.t('to')}
                </div>
                <div className="col-xs-3 control-date-to">
                  <Field
                    name="ClosureDate-To"
                    component="input"
                    type="date"
                    className="form-control"
                  />
                </div>
              </div>
            )}
            <div className="form-group">
              <label className="col-xs-4 control-label">
                {this.context.t('service_provider')}
              </label>
              <div className="col-xs-8">
                <Field
                  name="ContractorID"
                  component={(props) => (
                    <Select
                      {...props}
                      isSearchable={false}
                      placeholderTitle={this.context.t('select')}
                      clearable={true}
                      multi={true}
                      closeMenuOnSelect={false}
                      options={optionList.ContractorID}
                    />
                  )}
                />
              </div>
            </div>
            {false && (
              <div className="form-group">
                <label className="col-xs-4 control-label">
                  {this.context.t('days_detected')}
                </label>
                <div className="col-xs-2 control-numeric-opr">
                  <Field name="DetectedAtOpr" component={OprSelect} />
                </div>
                <div className="col-xs-6">
                  <Field
                    name="DetectedAt"
                    component="input"
                    type="number"
                    validate={positiveNum}
                    className="form-control"
                  />
                </div>
              </div>
            )}
            {user && user.isAQS &&
              <div className="form-group">
                <label className="col-xs-4 control-label">
                  {this.context.t('ranking')}
                </label>
                <div className="col-xs-8" style={{ paddingTop: '7px' }}>
                  <Field
                    name="showRanking"
                    component="input"
                    type="checkbox"
                  />
                </div>
              </div>
            }
            <div className="text-right">
              <button
                className="btn btn-success"
                type="submit"
                disabled={submitting}
                onClick={toggleSettingsDisplay}
              >
                {this.context.t('save_and_apply')}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

function validate(formProps) {
  const errors = {};
  if (positiveNum(formProps.DaysDetected)) {
    errors.DaysDetected = 'must be positive';
  }
  return errors;
}

AlertsSettings.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Decorate the form component
AlertsSettings = reduxForm({
  form: 'alerts-settings', // a unique name for this form
  enableReinitialize: true,
})(AlertsSettings);

export default AlertsSettings;
